import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import calenderIcon from "../../assets/images/top-calender-icon.svg";
import buldingIcon from "../../assets/images/top-building-icon.svg";
import backArrowIcon from "../../assets/images/top-back-arrow.svg";
import { InnCheckbox } from "../innCheckbox";
import { InnModalPopup } from "../innModalPopup";
import { useDispatch, useSelector } from "react-redux";
import platform from "platform";
import { propertyDetails, reservationData, roomCatgData, setHomeNavigate, signatureImagePath } from "../../reducer/selfCheckinSlice";
import moment from "moment";
import { InsertDigitalSigniture } from "../../services/selfCheckinService";
import { InnLoader } from "../innLoader";

function Registration1() {

    //#region State Variable
    const [showCalenderData, setShowCalenderData] = useState(false);
    const [showSeeBreakUp, setShowSeeBreakUp] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [showTermCondition, setShowTermCondition] = useState(false);
    const [roomCatogiryData, setRoomCatogiryData] = useState([]);
    const [subTotalAmount, setSubTotalAmount] = useState();
    const [allCharges, setAllCharges] = useState([]);
    const [finalTotal, setFinaltotal] = useState();
    const [isChecked, setIsChecked] = useState(true);
    const [htmlData, setHtmlData] = useState({
        content: { "mycustom-html": "<p>demo</p>" }
    });
    //#endregion

    //#region Local Variable
    const guestDetailObj = useSelector(reservationData);
    const signObj = useSelector(signatureImagePath)
    const propertyDetailObj = useSelector(propertyDetails);
    const roomCatgObj = useSelector(roomCatgData)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const wait = timeOut => {
        return new Promise(resolve => setTimeout(resolve, timeOut));
    }
    //#endregion

    //#region Function
    const fillRoomCatgDetail = () => {
        setRoomCatogiryData(roomCatgObj?.roomCatgDataWithMeal);
        setAllCharges(roomCatgObj?.allServiceAndCharges);
        setHtmlData(propertyDetailObj?.TermsCondition);
    }
    const amountCalculation = () => {
        let total = 0;
        roomCatogiryData.forEach((x) => {
            total += x?.TotalTarrif;
            setSubTotalAmount(total);
        });
        let finalAmt = 0;
        allCharges.forEach((x) => {
            finalAmt += x?.Tax;
        });
        let grossAmt = finalAmt + subTotalAmount
        setFinaltotal(grossAmt)
    }

    const onClickCompleteRegiButton = () => {
        if (!isChecked) {
            alert("Please accept terms and conditions")
        }
        else if (signObj.length === 0) {
            alert("Please add digital signature")
        }
        else {
            InsertSigniture()
        }
    }

    const InsertSigniture = () => {
        let para = {
            "Client_ID": guestDetailObj?.Client_ID,
            "Property_ID": guestDetailObj?.Property_ID,
            "Booking_No": guestDetailObj?.Booking_No,
            "DigitalSign": {
                // "fileAsBase64": JSON.parse(JSON.stringify(signObj)),
                "fileAsBase64": signObj,
                // "fileName": JSON.parse(JSON.stringify(guestDetailObj?.Property_ID + "_" + guestDetailObj?.Booking_No + ".jpeg")),
                "fileName": guestDetailObj?.Property_ID + "_" + guestDetailObj?.Booking_No + ".jpeg",
                "fileSize": 200,
                "fileType": "jpeg"
            },
            "Device": platform.os?.family,
            "Browser": platform?.name,
            "Deviceinfo": platform?.ua,
            "ExpectedArrTIme": "",
            "RoomPreference": "",
            "SpecialInstruction": ""
        }
        // console.log("Parameter :: ", para)
        setIsActive(true);
        InsertDigitalSigniture(para).then((d) => {
            wait(1000).then(() => setIsActive(false))
            if (d.data === false) {
                alert("Please varify field.")
            } else {
                navigate("/ThankYou")
            }
        }).catch((ex) => {
            wait(1000).then(() => setIsActive(false))
            navigate("/Registration1")
            console.log("insert sign error :: ", ex);
        });
    }

    //#endregion

    //#region UseEffect
    useEffect(() => {
        setIsChecked(true)
        setIsActive(true);
        fillRoomCatgDetail();
        amountCalculation();
        if (propertyDetailObj === undefined) {
            navigate("/Unauthorised")
        }
        // console.log(subTotalAmount, finalTotal)
        wait(1000).then(() => setIsActive(false))
    }, [subTotalAmount, finalTotal])
    //#endregion

    return (
        <div>
            <InnLoader className={isActive ? "active" : null}></InnLoader>
            <div className="wrapper">
                <div className="top-blue-bg">
                    <Link to="/Registration" >
                        <div className="top-back-arrow">
                            <img src={backArrowIcon} />
                        </div>
                    </Link>
                    <div className="top-blue-hdng">
                        <h2>Page Name</h2>
                    </div>
                    <div className="top-blue-bg-icon">
                        <div>
                            <img
                                onClick={() => {
                                    setIsActive(true)
                                    setShowCalenderData(!showCalenderData)
                                    wait(1000).then(() => setIsActive(false))
                                }}
                                src={calenderIcon}
                            />
                        </div>

                        <div style={{ marginLeft: 10 }}>
                            <img src={buldingIcon} onClick={() => {
                                navigate("/HomeInfo")
                                dispatch(setHomeNavigate("FromRegistration1Page"));
                            }} />
                        </div>
                    </div>
                </div>
                <div className="main-white-bg">
                    <div className="reg-detail text-left">
                        <h3>{guestDetailObj?.GuestName}</h3>
                    </div>
                    <div className="reg-detail m-btm20">
                        <div className="wdth50 bdr-rgt">
                            <p>{moment(new Date(guestDetailObj?.Arrival_Date)).format("DD MMM")} - {moment(new Date(guestDetailObj?.Departure_Date)).format("DD MMM")} </p>
                            <p>{guestDetailObj?.No_Of_Nights} Nights</p>
                        </div>
                        <div className="wdth50">
                            <p className="text-left p-lt15">Booking No: {guestDetailObj?.Booking_No}</p>
                            <p className="text-left p-lt15">{guestDetailObj?.No_Of_Rooms} Room {guestDetailObj?.Adult} Adults</p>
                        </div>
                    </div>
                    {
                        roomCatogiryData && roomCatogiryData.map((x) => {
                            return (
                                <div className="light-red-bg bdr-tp">
                                    <div className="room-detail bdr-tp">
                                        <div className="room-num">
                                            Room <br />{x?.No_Of_Rooms}
                                        </div>
                                        <div>
                                            <div className="room-facylity">
                                                <div>
                                                    <p>{x?.RoomCatg}</p>
                                                </div>
                                                <div>
                                                    <p>{x?.Adult} Adults</p>
                                                </div>
                                            </div>
                                            <div className="room-facylity">
                                                {
                                                    x?.InclSerName === "" ?
                                                        <></>
                                                        :
                                                        <h5>Meal Plan: {x?.InclSerName} Included</h5>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div className="reg-detail m-tp30">
                    <div className="room-rate-hdg bdr-rgt">
                        <div>Total Booking Value</div>
                        <div className="total-rate"> {guestDetailObj?.TotalBookingValue === 0 ? "0.00" : parseFloat(guestDetailObj?.TotalBookingValue).toFixed(2)} </div>
                    </div>
                    <button
                        onClick={() => {
                            setIsActive(true)
                            setShowSeeBreakUp(!showSeeBreakUp)
                            wait(1000).then(() => setIsActive(false))
                        }}
                        className="primary-btn m-lt15"
                    >
                        {" "}
                        SEE BREAKUP{" "}
                    </button>
                </div>
                <div className="parant-dt-div">
                    <label className="general-checkbox">
                        <InnCheckbox
                            checked={isChecked}
                            onChecked={(ischecked) => {
                                setIsChecked(ischecked)
                            }}>
                            <h4>
                                I agree to the{" "}
                                <span onClick={() => setShowTermCondition(!showTermCondition)}>
                                    Terms and Conditions
                                </span>
                            </h4>
                        </InnCheckbox>
                    </label>
                    <div className="sign-div">
                        <Link to="/Signature">
                            <div style={{ textAlign: "center" }}>
                                <img className="sign-img" src={signObj} /></div>
                            <div className="reg-sign">Digital Signature</div>
                        </Link>
                    </div>
                </div>

                <div className="reg-detail m-btm20">
                    <button className="drk-blue-btn"
                        onClick={onClickCompleteRegiButton}
                    >Complete Registration </button>
                </div>
            </div>

            <div className="overlay">
                <div className="overlay-background"></div>
                {/* <div className="overlay-content"><span className="spinner"></span>&nbsp;&nbsp;&nbsp;Loading
                </div> */}
            </div>
            <div className="hidden">
                <div className="loader-overlay"></div>
            </div>

            {showSeeBreakUp ? (
                <InnModalPopup Onclose={() => setShowSeeBreakUp(false)}>
                    <div className="modal-content x-small-popup">
                        <div
                            id="myModal3"
                            tabindex="-1"
                            role="dialog"
                            aria-labelledby="myModalLabel3"
                            className="model-popup"
                        >
                            <div role="document">
                                <div className="modal-header">
                                    <h4 className="modal-title">BREAKUP</h4>
                                </div>
                                <div className="modal-body scroll-overlay">

                                    <div>
                                        {
                                            roomCatogiryData && roomCatogiryData.map((x) => {
                                                return (
                                                    <div className="popup-flex">
                                                        <div className="wdth60 popup-brk-text">
                                                            {x?.No_Of_Rooms} {x?.RoomCatg} <br />
                                                            {
                                                                x?.InclSerName === "" ?
                                                                    <span>
                                                                        {x?.Adult} Adult {x?.Child} Child
                                                                    </span>
                                                                    :
                                                                    <span>
                                                                        With {x?.InclSerName} - {x?.Adult} Adult {x?.Child} Child
                                                                    </span>
                                                            }
                                                        </div>
                                                        <div className="wdth40 popup-brk-fgr">{parseFloat(x?.TotalTarrif).toFixed(2)}</div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="popup-flex">
                                        <div className="wdth60 popup-brk-text">Sub Total</div>
                                        <div className="wdth40 popup-brk-fgr">{parseFloat(subTotalAmount).toFixed(2)}</div>
                                    </div>
                                    <div className="popup-flex">
                                        {
                                            allCharges && allCharges.map((x) => {
                                                return (
                                                    <>
                                                        <div className="wdth60 popup-brk-text m-tp5">{x?.ChargeName}</div>
                                                        <div className="wdth40 popup-brk-fgr m-tp5">{x?.Tax}</div>
                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="popup-flex-bdr-btm"></div>
                                    <div className="popup-flex">
                                        <div className="wdth60 popup-brk-text-total">
                                            Final Total
                                        </div>
                                        <div className="wdth40 popup-brk-fgr-total">{parseFloat(finalTotal).toFixed(2)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </InnModalPopup>
            ) : null}

            {showCalenderData ? (
                <InnModalPopup Onclose={() => setShowCalenderData(false)}>
                    <div class="modal-content x-small-popup">
                        <div
                            id="myModal3"
                            tabindex="-1"
                            role="dialog"
                            aria-labelledby="myModalLabel3"
                            class="model-popup"
                        >
                            <div role="document">
                                <div class="reg-detail text-left">
                                    <h2>{guestDetailObj?.GuestName}</h2>
                                </div>
                                <div class="reg-detail p-btm30">
                                    <div class="wdth50 bdr-rgt">
                                        <p>{moment(new Date(guestDetailObj?.Arrival_Date)).format("DD MMM")} - {moment(new Date(guestDetailObj?.Departure_Date)).format("DD MMM")}</p>
                                        <p>{guestDetailObj?.No_Of_Nights} Nights</p>
                                    </div>
                                    <div class="wdth50">
                                        <p class="text-right">Booking No: {guestDetailObj?.Booking_No}</p>
                                        <p class="text-right">{guestDetailObj?.No_Of_Rooms} Room {guestDetailObj?.Adult} Adults</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </InnModalPopup>
            ) : null}

            {showTermCondition ? (
                <InnModalPopup Onclose={() => setShowTermCondition(false)}>
                    <div class="modal-content x-small-popup">
                        <div

                            id="myModal3"
                            tabindex="-1"
                            role="dialog"
                            aria-labelledby="myModalLabel3"
                            class="model-popup"
                        >
                            <div  >
                                <div class="modal-header">
                                    <h4 class="modal-title">
                                        Terms and Condition
                                    </h4>
                                </div>
                                <div class="modal-body">
                                    <div

                                        class="tc-popup-content scroll-overlay"
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: htmlData }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </InnModalPopup>
            ) : null}
        </div>
    );
}

export default Registration1;
